import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment';
import { ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK } from '@mummssoftware/global-context';
import { Scheduler } from '@mummssoftware/utils';
import { isResponse } from '@mummssoftware/utils/api/Request';
import { Bereavement, CarePlanFrequency, CarePlanProblems, ClearScripts, Facesheet, Measures, PatientAssistance, ProgressNotes, ActiveMedications, ActiveAndMaintainedMeds } from '@mummssoftware/utils/constants';
import { getHeaders } from '@mummssoftware/utils/utils';
import { INCLUDE_BEREAVEMENT, INCLUDE_PDF_CPF_NOTES, INCLUDE_PDF_MEDICATIONS_NOTES, SET_ASYNC_PDF_DATA_READY, SET_HISTORICAL_ROWS, SET_JSON_MEASURES, SET_PDF_BEREAV_NOTES, SET_PDF_CARE_PLAN_PROBLEMS, SET_PDF_CERT_APP_SNAPSHOT, SET_PDF_CPF_NOTES, SET_PDF_MEASURES_GRAPH_IMAGES, SET_PDF_MEDICATIONS_NOTES, SET_PDF_FACESHEET_DATA, SET_PDF_MEDICATIONS, SET_PDF_PROGRESS_NOTES, SET_PDF_RG_HASH, SET_PDF_RG_HASH_PRINT, SET_PDF_TASKS_NOTES, SET_PDF_WEEKLY_TASKS, SET_PDF_CAREGIVERS_INFO } from '../../MummsPDFGlobalContext/constants';
export const getAsyncPdfData = widgetsToLoad => {
  const facesheetPdf = widgetsToLoad.find(widget => widget.widgetName === Facesheet);
  const bereavementPdf = widgetsToLoad.find(widget => widget.widgetName === Bereavement);
  const carePlanProblemsPdf = widgetsToLoad.find(widget => widget.widgetName === CarePlanProblems);
  const carePlanFrequencyPdf = widgetsToLoad.find(widget => widget.widgetName === CarePlanFrequency);
  const measuresPdf = widgetsToLoad.find(widget => widget.widgetName === Measures);
  const clearscriptsPdf = widgetsToLoad.find(widget => widget.widgetName === ClearScripts);
  const progressNotesPdf = widgetsToLoad.find(widget => widget.widgetName === ProgressNotes);
  const patientAssistancePdf = widgetsToLoad.find(widget => widget.widgetName === PatientAssistance);

  if (facesheetPdf) {
    const {
      patientNumber,
      keycloak,
      agency,
      dispatchReactPDF
    } = facesheetPdf;
    getHeaders(keycloak).then(headers => {
      headers.set('Authorization', `Bearer ${keycloak === null || keycloak === void 0 ? void 0 : keycloak.token}`);
      const url = `${process.env.REACT_APP_FACESHEET_URL}/v1/facesheets/${agency}/${patientNumber}.json`;
      const decoder = new TextDecoder('utf-8');
      fetch(url, {
        method: 'GET',
        headers
      }).then(response => {
        if (response.status !== 404) {
          const reader = response.body.getReader();
          let html = '';
          reader.read().then(function processText({
            done,
            value
          }) {
            if (done) {
              let dto;

              try {
                if (html) {
                  dto = JSON.parse(html);
                  dispatchReactPDF({
                    type: SET_PDF_FACESHEET_DATA,
                    payload: dto
                  });
                }
              } catch (e) {
                console.log('Error parsing facesheet json: ', e);
              }

              return;
            }

            html += decoder.decode(value);
            reader.read().then(processText);
          });
        }
      }).catch(err => 'There was an error loading Facesheet');
    });
  }

  if (bereavementPdf) {
    const {
      patientNumber,
      pim,
      dispatchReactPDF
    } = bereavementPdf;
    pim && pim.query('patientcaregivers_vw', {
      select: `*`,
      patientNumber: `eq.${patientNumber}`
    }, 'pimreader').then(res => {
      if (!isResponse(res)) {
        dispatchReactPDF({
          type: SET_PDF_CAREGIVERS_INFO,
          payload: res
        });
      }
    });
  }

  if (carePlanProblemsPdf) {
    const {
      patientNumber,
      latest,
      mode,
      agency,
      fromDate,
      toDate,
      observation,
      dispatchReactPDF
    } = carePlanProblemsPdf;

    if (fromDate && toDate) {
      const fromDateFormatted = moment(fromDate).format('MM-DD-YYYY');
      const toDateFormatted = moment(toDate).format('MM-DD-YYYY');
      observation && observation.getPatientCarePlanProblemsByDate(patientNumber, latest, mode, fromDateFormatted, toDateFormatted, agency).then(res => {
        if (!isResponse(res)) {
          dispatchReactPDF({
            type: SET_PDF_CARE_PLAN_PROBLEMS,
            payload: res
          });
        }
      });
    } else {
      observation && observation.getPatientCarePlanProblemsv2(patientNumber, latest, mode, agency).then(res => {
        if (!isResponse(res)) {
          dispatchReactPDF({
            type: SET_PDF_CARE_PLAN_PROBLEMS,
            payload: res
          });
        }
      });
    }
  }

  if (carePlanFrequencyPdf) {
    const {
      patient,
      keycloak,
      fromDate,
      toDate,
      getAllRgHashes,
      agency
    } = carePlanFrequencyPdf;

    if (keycloak && patient) {
      const scheduler = new Scheduler({
        url: process.env.REACT_APP_PIM_BASEURL,
        siteId: patient.siteId.toString(),
        keycloak
      });
      scheduler.getPatientCarePlanFrequencies(agency || '', patient.siteId.toString(), '', patient.patientNumber, '', fromDate || 'null', toDate || 'null').then(res => {
        // getAllRgHashes sets the rgHash's down the line (drilled)
        if (!isResponse(res) && getAllRgHashes) {
          getAllRgHashes(_objectSpread(_objectSpread({}, carePlanFrequencyPdf), {}, {
            carePlans: res
          }));
        }
      });
    } else {
      getAllRgHashes && getAllRgHashes(carePlanFrequencyPdf);
    }
  }

  if (patientAssistancePdf) {
    const {
      patientNumber,
      siteId,
      dispatchReactPDF,
      observation,
      agency,
      fromDate,
      toDate,
      printView
    } = patientAssistancePdf;
    const adminfromdate = fromDate ? moment(fromDate).format('MM-DD-YYYY') : undefined;
    const admintodate = toDate ? moment(toDate).format('MM-DD-YYYY') : undefined;
    const includedetails = printView === 'Details';
    observation && observation.getPatientWeeklyTasks(agency, siteId, patientNumber, adminfromdate, admintodate, includedetails).then(res => {
      if (!isResponse(res)) {
        dispatchReactPDF({
          type: SET_PDF_WEEKLY_TASKS,
          payload: res
        });
      }
    });
    observation && observation.getWidgetPnNotes(patientNumber, agency, ENTITY_PATIENT_CARE_PLAN_PROBLEM_TASK).then(res => {
      if (!isResponse(res)) {
        dispatchReactPDF({
          type: SET_PDF_TASKS_NOTES,
          payload: res
        });
      }
    });
  }

  if (measuresPdf) {
    const {
      patientNumber,
      dispatchReactPDF,
      observation,
      fromDate,
      toDate,
      agency
    } = measuresPdf;

    if (fromDate && toDate && observation && patientNumber) {
      const fromDateFormatted = moment(fromDate).format('MM-DD-YYYY');
      const toDateFormatted = moment(toDate).format('MM-DD-YYYY');
      observation.getPrintPatientMeasures(patientNumber, agency, fromDateFormatted, toDateFormatted).then(measures => {
        if (!isResponse(measures)) {
          observation.getAllMeasureTypes(patientNumber, agency).then(allMeasuresTypes => {
            if (!isResponse(allMeasuresTypes)) {
              dispatchReactPDF({
                type: SET_JSON_MEASURES,
                payload: {
                  measures,
                  allMeasuresTypes
                }
              });
            }
          });
        }
      });
    } else if (observation && patientNumber) {
      observation.getPrintPatientMeasures(patientNumber, agency).then(measures => {
        if (!isResponse(measures)) {
          observation.getAllMeasureTypes(patientNumber, agency).then(allMeasuresTypes => {
            if (!isResponse(allMeasuresTypes)) {
              dispatchReactPDF({
                type: SET_JSON_MEASURES,
                payload: {
                  measures,
                  allMeasuresTypes
                }
              });
            }
          });
        }
      });
    }
  }

  if (clearscriptsPdf) {
    const {
      clearscripts,
      fromDate,
      toDate,
      patientNumber,
      agency,
      printView,
      dispatchReactPDF
    } = clearscriptsPdf;
    clearscripts.getMedsWithRange(patientNumber, agency, fromDate, toDate, medsConfigToType(printView)).then(res => {
      dispatchReactPDF({
        type: SET_PDF_MEDICATIONS,
        payload: res
      });
    });
  }

  if (progressNotesPdf) {
    const {
      observation,
      patientNumber,
      agency,
      dispatchReactPDF,
      fromDate,
      toDate
    } = progressNotesPdf;

    if (fromDate && toDate && patientNumber && agency) {
      const fromDateFormatted = moment(fromDate).format('MM-DD-YYYY');
      const toDateFormatted = moment(toDate).format('MM-DD-YYYY');
      observation && observation.getPrintProgressNotes(patientNumber, agency, fromDateFormatted, toDateFormatted).then(res => {
        if (!isResponse(res)) {
          dispatchReactPDF({
            type: SET_PDF_PROGRESS_NOTES,
            payload: res
          });
        }
      });
    } else if (patientNumber && agency) {
      observation && observation.getProgressNotes(patientNumber, agency).then(res => {
        if (!isResponse(res)) {
          dispatchReactPDF({
            type: SET_PDF_PROGRESS_NOTES,
            payload: res
          });
        }
      });
    }
  }
}; // map printView string to appropriate clearscripts endpoint param

const medsConfigToType = printView => {
  let type = '';

  switch (printView) {
    case ActiveMedications:
      type = 'active';
      break;

    case ActiveAndMaintainedMeds:
      type = 'activeandmaintained';
      break;

    default:
      type = 'all';
      break;
  }

  return type;
};

export const clearPdfData = dispatchReactPDF => {
  dispatchReactPDF({
    type: SET_PDF_RG_HASH,
    payload: null
  });
  dispatchReactPDF({
    type: SET_HISTORICAL_ROWS,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_CARE_PLAN_PROBLEMS,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_RG_HASH_PRINT,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_PROGRESS_NOTES,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_MEASURES_GRAPH_IMAGES,
    payload: null
  });
  dispatchReactPDF({
    type: SET_JSON_MEASURES,
    payload: null
  });
  dispatchReactPDF({
    type: SET_ASYNC_PDF_DATA_READY,
    payload: []
  });
  dispatchReactPDF({
    type: SET_PDF_MEDICATIONS,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_MEDICATIONS_NOTES,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_CPF_NOTES,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_BEREAV_NOTES,
    payload: null
  });
  dispatchReactPDF({
    type: INCLUDE_PDF_CPF_NOTES,
    payload: ''
  });
  dispatchReactPDF({
    type: INCLUDE_PDF_MEDICATIONS_NOTES,
    payload: ''
  });
  dispatchReactPDF({
    type: SET_PDF_CERT_APP_SNAPSHOT,
    payload: null
  });
  dispatchReactPDF({
    type: INCLUDE_BEREAVEMENT,
    payload: ''
  });
  dispatchReactPDF({
    type: SET_PDF_WEEKLY_TASKS,
    payload: null
  });
  dispatchReactPDF({
    type: SET_PDF_TASKS_NOTES,
    payload: null
  });
};